/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function increaseValue(id) {
  var value = parseInt(document.getElementById(id).value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  document.getElementById(id).value = value;
}

function decreaseValue(id) {
  var value = parseInt(document.getElementById(id).value, 10);
  value = isNaN(value) ? 0 : value;
  value < 1 ? value = 1 : '';
  value--;
  document.getElementById(id).value = value;
}
(function($) {
   $("#wholesale-submit").click(function(event){
      event.preventDefault();
        console.log("Hit it");
        var textFieldContent ="";
        var allProds = $(".ProductItem");
        allProds.each(function(index, value){
          let prodQty = $(this).find(".prod-qty").val();
          if ( prodQty > 0 ) {
          let prodId = $(this).find(".prod-id").val();
          let prodTitle = $(this).find(".prod-title").val();
          let prodSize =  $(this).find(".prod-size").val();
          textFieldContent += `WholeSale Inquiry \nTitle: ${prodTitle} \nSize: ${prodSize} \nQty: ${prodQty} \nId: ${prodId} \n \n \n`;
          }
        })
        $("#ContactFormMessage").val(textFieldContent);
          $(".contact-form").submit();
        })
}(jQuery));
